// extracted by mini-css-extract-plugin
export var elevatedFrame = "_1-2";
export var elevatedShell = "_1-1";
export var shell = "_1-0";